/* eslint-disable indent */
import React from 'react';
import styled from 'styled-components';

const Base = styled.div`
  display: flex;
  gap: ${props => (props.gap ? `${props.gap}px`.replace('pxpx', 'px') : 0)};
  padding: ${props => props.padding || 0};
`;

const VBOX = styled(Base)`
  width: 100%;
  flex-direction: column;

  justify-content: ${props =>
    props.spaceAround ? 'space-around' : props.center ? 'center' : props.top ? 'flex-start' : 'space-between'};

  align-items: ${props => (props.center ? 'center' : props.right ? 'flex-end' : props.stretch ? 'strecht' : 'flex-start')};
  ${props =>
    props.flip
      ? `
        flex-direction:row;
    `
      : ''}
`;

const HBOX = styled(Base)`
  width: ${props => (props.autoWidth ? 'auto' : '100%')};
  justify-content: ${props =>
    props.spaceAround
      ? 'space-around'
      : props.center
      ? 'center'
      : props.left
      ? 'flex-start'
      : props.right
      ? 'flex-end'
      : 'space-between'};
  align-items: ${props =>
    props.vCenter
      ? 'center'
      : props.vBottom
      ? 'flex-end'
      : props.stretch
      ? 'stretch'
      : props.baseline
      ? 'baseline'
      : 'flex-start'};

  ${props =>
    props.flip
      ? `
        flex-direction:column;
    `
      : ''}

  ${props => (props.flexWrap ? 'flex-wrap: wrap' : '')}
`;

export function VBox(props) {
  return (
    <VBOX {...props} className={`box vbox ${props.className || ''}`}>
      {props.children}
    </VBOX>
  );
}

export function HBox(props) {
  return (
    <HBOX {...props} className={`box hbox ${props.className || ''} `}>
      {props.children}
    </HBOX>
  );
}
